import { render, staticRenderFns } from "./ProductDeliveryState.vue?vue&type=template&id=15b06e0b&"
import script from "./ProductDeliveryState.vue?vue&type=script&lang=js&"
export * from "./ProductDeliveryState.vue?vue&type=script&lang=js&"
import style0 from "./ProductDeliveryState.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports